import CustomButton from '@/DesignSystem/components/button/CustomButton';
import { Grid, Typography } from '@mui/material';

const InformaciónRelacionadaSection = ({ title, icon }) => {
    return (
        <Grid size={4}>
            <CustomButton
                variant="outlined"
                color="secondary"
                sx={{
                    p: 0,
                    width: '100%',
                    borderColor: 'border.main',
                    minHeight: '24px',
                }}
                height="24px"
            >
                <Typography fontSize={12} sx={{ ml: 0.25 }}>
                    {title}
                </Typography>
            </CustomButton>
        </Grid>
    );
};

const InformaciónRelacionada = () => {
    return (
        <>
            {/* <Typography variant="h2" fontSize={15} mb={1}>
                Información Relacionada
            </Typography>
            <Grid container spacing={1}>
                <InformaciónRelacionadaSection title="RDP Previa" />
                <InformaciónRelacionadaSection title="Convocatoria" />
                <InformaciónRelacionadaSection title="RDP Posterior" />
            </Grid> */}
        </>
    );
};

export default InformaciónRelacionada;
